import type { TeamGameResponse } from '@dto/api';
import { OverlaySettings } from '@hooks/useOverlaySettings';
interface TeamPlayer {
  id: string;
  createdBy: string;
  createdBecause: string;
  createdTs: number;
  modifiedUser: string;
  modifiedTs: number;
  nameFirst: string;
  nameLast: string;
  jerseyNum: string;
  embedNameFirstLevel: number;
  embedNameLastLevel: number;
  externalData: Record<string, unknown>;
}

interface TeamImage {
  category: string;
  large: string;
  small: string;
}

export enum TeamRole {
  ADMIN = 'Admin',
  COACH = 'Coach',
  FOLLOWER = 'Follower',
}

interface Schedule {
  upcoming: TeamGameResponse[];
  past: TeamGameResponse[];
  today: TeamGameResponse[];
}

interface Team {
  createdTs: number;
  embedNameFirstLevel: number;
  embedNameLastLevel: number;
  isEmbedImageVideo: boolean;
  isEmbedImagePublicWebsite: boolean;
  isNameOnPublicWebsite: boolean;
  publicPublishLevel: number;
  ageLevel: string;
  id: string;
  imageLogo: TeamImage | null;
  nameLocation: string;
  nameHandle: string;
  nameLong: string;
  roles: string[];
  sport: string;
  createdBecause: string;
  imageCover: TeamImage | null;
  players: Array<TeamPlayer>;
  nameMed: string;
  nameShort: string;
  season: number;
  zipCode: string;
  isAge13Plus: boolean;
  colorPrimary: string;
  invitePhoneNumberList: string[];
  inviteAdminPhoneNumberList: string[];
  isArchived: boolean;
  isNotifyCommunityTeamPlayerUpdates: boolean;
  overlaySettings: OverlaySettings;
  publishCrosspostMode: string;
  scoreTeamIdList: string[];
  accountFeatures: {
    pro: boolean;
  };
  pin: string | null;
  nameHandleLower: string;
  scoringService: string;
  socialInstagramHandle: string;
  socialFacebookUrl: string;
  socialTwitterHandle: string;
}

export { TeamGameResponse, Team, TeamImage, TeamPlayer, Schedule };
